import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";


import { Navbar, Hero, Feature, MatchRoomate, Footer } from "./components";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsCondition from "./components/TermsCondition";
import DeleteAccount from "./components/DeleteAccount";
import ChildSafetyStandards from "./components/ChildSafetyStandards";
import Support from "./components/Support";
const Home = () => (
  <>
    <Hero />
    <Feature />
    <MatchRoomate />
  </>
);

const App = () => {
  return (
    <Router>
      <div className="scroll-smooth h-full">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Feature />} />
          <Route path="/match-roommate" element={<MatchRoomate />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/terms-condition" element={<TermsCondition/>} />
          <Route path="/delete-account" element={<DeleteAccount/>} />
          <Route path="/child-saftey-standards" element={<ChildSafetyStandards/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
